// @flow
import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import {hashedClasses, withCssModule} from '@pb/kit-util-with-css-module';
import styles from './dropzone.component.module.styl';

const classNames = withCssModule(styles);
const classes = hashedClasses(styles);

type Props = {|
    /**
     *  The onDropAccepted method will be called if all dropped files were accepted
     */
    onDropAccepted?: (acceptedFiles: Array<File>) => void,
    /**
     *  The onDropRejected method will be called if any of the dropped files was rejected.
     */
    onDropRejected?: (rejectedFiles: Array<File>) => void,
    /**
     * The onClick method will be called if the drop zone was clicked
     */
    onClick?: (event: SyntheticMouseEvent<>) => void,
    /**
     * The onDrop method provides you with an array of Files which you can then send to a server
     */
    onDrop: (acceptedFiles: Array<File>, rejectedFiles: Array<File>) => void,
    /**
     * Mix which will be applied to element
     */
    mix: ?string,
    children: any,
    /**
     * Max size of file in bytes
     */
    maxSize?: number,
    /**
     * Allows bulk upload
     */
    multiple?: boolean,
    /**
     * Array with mime-types which will be accepted
     */
    accept?: string,
|};

export class DropZone extends Component<Props> {
    static defaultProps = {
        accept: '',
        maxSize: Infinity
    };

    render() {
        const {
            onDropRejected,
            onDropAccepted,
            onClick,
            onDrop,
            accept,
            maxSize,
            multiple,
            children,
            mix
        } = this.props;

        const dropzoneClasses = classNames('dropzone-component', mix ? mix : '');

        return (
            <Dropzone
                className={dropzoneClasses}
                activeClassName={classes['dropzone-component_active']}
                rejectClassName={classes['dropzone-component_reject']}

                {...{onDrop, onDropAccepted, onDropRejected, onClick, accept, maxSize, multiple}}>
                <div className={classes['dropzone-component_reject']}>
                    {children}
                </div>
            </Dropzone>);
    }
}
